export const HTTP_STATUS_400 = {
    status: 400,
    message: 'error_400',
};
export const HTTP_STATUS_401 = {
    status: 401,
    message: 'error_401',
};
export const HTTP_STATUS_403 = {
    status: 403,
    message: 'error_403',
};
export const HTTP_STATUS_404 = {
    status: 404,
    message: 'error_404',
};
export const HTTP_STATUS_409 = {
    status: 409,
    message: 'error_409',
};
export const HTTP_STATUS_500 = {
    status: 500,
    message: 'error_500',
};
export const HTTP_STATUS_502 = {
    status: 502,
    message: 'error_502',
};
export const HTTP_STATUS_503 = {
    status: 503,
    message: 'error_503',
};
export const HTTP_STATUS_504 = {
    status: 504,
    message: 'error_504',
};
export const HTTP_STATUS_507 = {
    status: 507,
    message: 'error_507',
};
